export default {
    places: (state) => {
        return state.places;
    },
};